import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ToasterModule } from 'angular2-toaster';
import { HttpClientModule } from '../../node_modules/@angular/common/http';
// Components
import { ProblemIssueDialogComponent } from './problem-issue-dialog/problem-issue-dialog.component';
// Layouts
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { AppComponent } from './app.component';
import { BaseComponent } from './base.component';
import { AppRoutes } from './app.routing';
import { BranchDialogComponent } from './branch-dialog/branch-dialog.component';
import { ProvinceDialogComponent } from './province-dialog/province-dialog.component';
import { ImageDialogComponent } from './image-dialog/image-dialog.component';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { AuthGuard } from './shared/Guards/auth.guard';
import { BaseDataGuard } from './shared/Guards/base-data.guard';
import { FrontPageAuthGuard } from './shared/Guards/front-page-auth.guard';
import { MasterGuard } from './shared/Guards/master.guard';
import { SayehGuard } from './shared/Guards/sayeh.guard';
import { UserGuard } from './shared/Guards/user.guard';
import { MessageBox } from './shared/message-box/message-box';
import { SecurityService } from './shared/services/security.service';
import { BottomSheetComponent } from './bottom-sheet/bottom-sheet.component';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { CustomPreloadingStrategyService } from './cache-services/custom-preloading-strategy.service';


import 'zone.js';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { SwiperConfigInterface, SwiperModule, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { BranchService } from './shared/services/branch.service';
import { PermissionService } from './shared/services/permission.service';
import { RequestCacheModule } from './shared/request-cache/request-cache.module';

import { environment } from '../environments/environment';
import { ENVIRONMENTER } from '../environments/enviromenter/environmenter-token';
import { ProblemDetailsComponent } from './newfrontpage/problem-details/problem-details.component';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TreeModule } from '@circlon/angular-tree-component';
import { ServiceWorkerModule } from '@angular/service-worker';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

@NgModule({
  declarations: [
    AppComponent,
    BaseComponent,
    AlertDialogComponent,
    ProblemIssueDialogComponent,
    BranchDialogComponent,
    ProvinceDialogComponent,
    MessageBox,
    ImageDialogComponent,
    BottomSheetComponent,
    ProblemDetailsComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'socialsrv' }),
    RouterModule.forRoot(AppRoutes, { scrollPositionRestoration: 'enabled', initialNavigation: 'enabled', preloadingStrategy: CustomPreloadingStrategyService }),
    BrowserAnimationsModule,
    HttpClientModule,
    ToasterModule.forRoot(),
    TransferHttpCacheModule,
    RequestCacheModule,

    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatCardModule,
    MatCheckboxModule,
    FlexLayoutModule,
    CommonModule,
    SwiperModule,
    TreeModule,
    ServiceWorkerModule.register("./ngsw-worker.js", {
      enabled: environment.production,
      registrationStrategy: "registerWhenStable",
    }),


    //SharedModule,

  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: '' },
    { provide: 'isBrowser', useValue: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    },
    { provide: ENVIRONMENTER, useValue: environment },

    //{ provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true },

    BranchService,
    PermissionService,
    SecurityService,
    AuthGuard,
    UserGuard,
    MasterGuard,
    SayehGuard,
    BaseDataGuard,
    FrontPageAuthGuard,
    MessageBox,
    Title,
  ],
  entryComponents: [
    ProblemIssueDialogComponent,
    AlertDialogComponent,
    BranchDialogComponent,
    ProvinceDialogComponent,
    ImageDialogComponent,
    BottomSheetComponent,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
  }
}
